
<template>
    <div class="container mx-auto my-6 px-4">
        <div class="flex flex-col items-start sm:flex-row sm:justify-between gap-4">
            <JobCode />
    
            <div v-if="!isEmbed" class="flex flex-col">
                <img src="@/assets/img/qr-code-rnai-science-ph1.png" alt="Content QR Code" class="w-32" />
                <p class="text-xs text-gray-600 text-center">Scan to view content<br/>on RNAiScience.com</p>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import JobCode from './JobCode.vue';

const isEmbed = computed(() => {
    return process.env.VUE_APP_IS_EMBED === 'true';
})
</script>